































































































































































































import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
import type {ContentPack, CurrentGame, GameRestrictions, GameSettings, Player, StartPackMessage} from "../../../types";
import DateHelper from "../../helpers/DateHelper";
import RestartGameModal from "../Modal/RestartGameModal.vue";
import EventApi from "../../api/EventsApi";
import FpsCounter from "../Widgets/FpsCounter.vue";
import MessageHelper from '../../helpers/MessageHelper';
import {Tool} from "../../helpers/Tool";
import InviteBtn from "../Widgets/InviteBtn.vue";
import {LayoutTypes} from "../../../enums/layout-types/LayoutTypes";

const TASK_STATE_TYPE_PRESET = 1;
const TASK_STATE_TYPE_CUSTOM = 2;

@Component({
    components: {
        InviteBtn,
        FpsCounter,
        RestartGameModal,
    }
})

export default class Header extends Vue {
    //TODO описать типы вместо any
    @Prop({required: true}) private readonly gameRestrictions!: GameRestrictions;
    @Prop({required: true}) private readonly interfaceGuideImages!: Array<string>;
    @Prop({required: true}) private readonly tableIsOn!: boolean;
    @Prop({required: true}) private readonly layoutType!: string;

    private catalogIsOpened: boolean = false;
    private helpIsVisible: boolean = false;
    private restartGameModalIsVisible: boolean = false;
    private conferenceReady: boolean = false;
    private settingsModalIsVisible: boolean = false;
    private fpsCounterIsVisible: boolean = false;
    private defaultGame: CurrentGame|null = null;
    private defaultPack: ContentPack|null = null;

    private selectedGame: null|CurrentGame = null;
    private selectedPack: null|ContentPack = null;

    private reactionIsActive: boolean = false;
    private diceIsActive: boolean = false;

    private inputValue: boolean = false;
    private switcherWidth: string = '';
    private roomTimer: number|null = null;
    private allowSettingsClick: boolean = true;
    private urlRoom: string = '';

    mounted(): void
    {
        this.inputValue = this.tableIsOn;
        this.urlRoom = window.location.href;

        EventApi.addEventListener(EventApi.VIDEO_CONFERENCE_READY, () => {
            this.conferenceReady = true;
        });

        EventApi.addEventListener(EventApi.CLOSE_SETTINGS_MODAL, () => {
            setTimeout(() => {
                this.allowSettingsClick = true;
            }, 1000);
        });

        EventApi.addEventListener(EventApi.OPEN_CATALOG, this.openCatalog);
        EventApi.addEventListener(EventApi.TOGGLE_FPS_COUNTER, this.toggleFps);
        EventApi.addEventListener(EventApi.SHOW_RESTART_GAME_MODAL, this.showRestartGameModal);
    }

    updated(): void
    {
        this.getSwitcherWidth();
    }

    beforeDestroy(): void
    {
        EventApi.removeEventListener(EventApi.OPEN_CATALOG, this.openCatalog);
        EventApi.removeEventListener(EventApi.TOGGLE_FPS_COUNTER, this.toggleFps);
        EventApi.removeEventListener(EventApi.SHOW_RESTART_GAME_MODAL, this.showRestartGameModal);
    }

    @Watch('tableIsOn')
    changeInputValue(newVal: boolean, oldVal: boolean): void
    {
        this.inputValue = newVal;

        EventApi.triggerEvent(EventApi.SHOW_PAGE_LOADER);
        if (this.inputValue) {
            EventApi.triggerEvent(EventApi.EVENT_CHANGE_LAYOUT, LayoutTypes.LAYOUT_TABLE);
        } else {
            EventApi.triggerEvent(EventApi.EVENT_CHANGE_LAYOUT, LayoutTypes.LAYOUT_DEFAULT);
        }
    }

    /**
     * Лейайт с ситами на столе
     * @private
     */
    private get isSeatOnTableLayout(): boolean
    {
        return this.layoutType === LayoutTypes.LAYOUT_SEAT_ON_TABLE;
    }

    /**
     * Список всех игроков
     * @private
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Кол-во занятых ситов
     * @private
     */
    private get takenSeatsCount(): number
    {
        let playerCount = 0;
        if (this.players && this.players.length) {
            playerCount = this.players.filter((player) => {
                return player.connectionStatus !== 'guest';
            }).length;
        }
        return playerCount;
    }

    /**
     * Начата ли игра
     */
    private get gameIsStarted(): boolean
    {
        if (typeof this.gameState === 'undefined' || typeof this.gameState.tasks === 'undefined') {
            return false;
        }
        return this.gameState.tasks.state.game_started;
    }

    /**
     * Стейт игры
     * @private
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Виден ли переключатель стол/рука
     */
    private get tableTaskTogglerIsVisible(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewTasksFieldSwitch;
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Настройки текущей игры
     */
    private get currentActivitySettings(): GameSettings|null
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Назввание игры
     */
    private get gameName(): string
    {
        if (this.game && this.gameIsStarted) {
            return this.game.name;
        }
        // @ts-ignore
        return this.$t('message.choose_game');
    }

    /**
     * Игрок
     */
    private get player(): Player|null
    {
        const filtered = this.playersData.filter(player => {
            return player.id === this.playerId;
        });

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }

        return null;
    }

    /**
     * Данные об игроках
     */
    private get playersData(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Кол-во гостей
     * @private
     */
    private get guestsAmount(): number
    {
        return this.playersData.filter((player) => {return player.connectionStatus === 'guest'}).length;
    }

    /**
     * ID игрока
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): string
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /** Статус подключения: активный игрок на сите */
    private get isActive(): boolean
    {
        return this.playerConnectionStatus === 'active';
    }

    /** Статус подключения: гость */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /**
     * Текущая игра (активность)
     */
    private get game(): null|CurrentGame
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Время жизни комнаты
     * @returns {string}
     */
    private get roomLifetime(): string
    {
        return DateHelper.secondsToDate(this.gameRestrictions.lifetime);
    }

    /**
     * Ограничение активного времени
     * @returns {string}
     */
    private get getTotalActiveTime(): string
    {
        return DateHelper.convertSecondsToHS(this.gameRestrictions.activeTime.total);
    }

    /**
     * Использованное активное время
     * @returns {string}
     */
    private get getUsedActiveTime(): string
    {
        return DateHelper.convertSecondsToHS(this.gameRestrictions.activeTime.used);
    }

    /**
     * Переключить видимость стола
     */
    private toggleTableVisibility(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-table-visibility', this.inputValue);
        this.getSwitcherWidth();
        if (typeof this.$refs.toggleCheckbox !== 'undefined') {
            (this.$refs.toggleCheckbox as HTMLElement).blur();
        }
    }

    /**
     * Ширина активного эл-та свитчера
     */
    private getSwitcherWidth(): void
    {
        const toggler = this.$refs.tasks as HTMLElement;
        const table = this.$refs.table as HTMLElement;
        if (typeof toggler !== 'undefined') {
            if (!this.tableIsOn ) {
                this.switcherWidth = toggler.offsetWidth + 'px';
            } else {
                this.switcherWidth = table.offsetWidth + 'px';
            }
        }
    }

    /**
     * Открыть/закрыть каталог
     * @private
     */
    private toggleCatalog(): void
    {
        this.catalogIsOpened = !this.catalogIsOpened;
        EventApi.triggerEvent(EventApi.OPEN_CATALOG, {game: this.selectedGame, pack: this.selectedPack});

    }

    private toggleFps(): void
    {
        this.fpsCounterIsVisible = !this.fpsCounterIsVisible;
    }

    /**
     * Закрыть каталог
     * @private
     */
    private closeCatalog(): void
    {
        this.catalogIsOpened = false;
    }

    /**
     * Открыть каталог
     * @private
     */
    private openCatalog(e: any): void
    {
        if (e.detail) {
            this.defaultGame = e.detail.game;
            this.defaultPack = e.detail.pack;
        }
        this.catalogIsOpened = true;
    }

    /**
     * Показать правила игры
     */
    private showGuide(): void
    {
        this.$emit('show-guide');
    }

    /**
     * Показать/скрыть справку
     */
    private toggleHelp(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.helpIsVisible = !this.helpIsVisible;
        if (this.helpIsVisible) {
            MessageHelper.getState();
            Tool.startUpdateGameStateTimer(60000);
        } else {
            Tool.endUpdateGameStateTimer();
        }
    }

    /**
     * скрыть справку
     */
    private closeHelp(): void
    {
        this.helpIsVisible = false;
        if (this.roomTimer) {
            clearInterval(this.roomTimer);
        }
    }

    /**
     * Показать правила
     * @private
     */
    private showRules(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('show-rules');
    }

    /**
     * Показать форму баг-репорта
     * @private
     */
    private showBugReportForm(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('show-bug-report');
    }

    /**
     * Показать модалку заморозки комнаты
     * @private
     */
    private showFreezeRoomModal(): void
    {
        this.$emit('show-freeze-room-modal');
    }

    /**
     * Показать модалку смены урла комнаты
     * @private
     */
    private showChangeRoomUrlModal(): void
    {
        this.$emit('show-change-room-url-modal');
    }

    /**
     * Запустить игру
     */
    private startGame(data: StartPackMessage): void
    // private startGame(data: any): void
    {
        this.selectedGame = data.selectedGame;
        this.selectedPack = data.selectedPack;
        this.$emit('send-message', 'getContentPackTasks', data);
    }

    /**
     * Перезапустить игру
     */
    private restartGame(type: string, data: StartPackMessage): void
    {
        this.$emit('send-message', type, data);
    }

    /**
     * Показать модалку "присоединиться к игре"
     */
    private showSettingsModal(): void
    {
        if (!this.allowSettingsClick) {
            return;
        }
        this.allowSettingsClick = false;
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.settingsModalIsVisible = true;
        this.$emit('show-settings-modal');
        setTimeout(() => {
            this.settingsModalIsVisible = false;
        }, 2000);
    }

    /**
     * Показать модалку перезапуска игры
     * @private
     */
    private showRestartGameModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.restartGameModalIsVisible = true;
    }

    /**
     * Скрыть модалку перезапуска игры
     * @private
     */
    private hideRestartGameModal(): void
    {
        this.restartGameModalIsVisible = false;
    }

    /**
     * Показать стартовую страницу
     */
    public showWelcomePage(): void
    {
        if (this.isGuest) {
            return;
        }
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.sendMessage('resetState', {});
    }

    /**
     * Скрыть/показать реакции
     * @private
     */
    private toggleLikesVisibility(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.reactionIsActive = !this.reactionIsActive;
    }

    /**
     * Отправить реакцию
     */
    private sendReaction(type: string)
    {
        const data = {
            type: type
        };

        this.$emit('send-message', 'reaction', data);
    }

    /**
     * Скрыть/закрыть кубики
     * @private
     */
    private toggleDiceVisibility(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.diceIsActive = !this.diceIsActive;
        this.$emit('toggle-dice');
    }

    /**
     * Обработать реакцию
     */
    public processReaction(data: any)
    {
        // @ts-ignore
        this.$refs.reactionButtons.processReaction(data);
    }
}
